<template>
  <img
    class="favourite"
    src="../../assets/images/article/favourite.svg"
    alt=""
    @click="handleCheckFavourite"
  />
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ArticleFavourite',
  props: {
    favouriteId: {
      type: Number,
      default: 0,
      require: true
    },
  },
  methods: {
    ...mapActions(['deleteFavourite']),
    handleCheckFavourite(event) {
      event.preventDefault()
      const resoult = window.confirm('確定從我的收藏移除？')
      if (resoult) {
        this.deleteFavourite(this.favouriteId)
      }
    },
  }
}
</script>

<style scoped lang="scss">
.favourite {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
  cursor: pointer;
}
</style>